export type AppEnv = 'dev' | 'uat' | 'prod';

export function inferEnv(): AppEnv {
  if (typeof window === 'undefined') return 'dev';
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local')) {
    return 'dev';
  }
  if (hostname.includes('uat') || hostname.includes('staging')) {
    return 'uat';
  }
  return 'prod';
}
